'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var reactHookForm = require('react-hook-form');
var createFieldControl = require('../lib/form/createFieldControl.js');
var useFieldOptions = require('../lib/parse/useFieldOptions.js');
var DefaultSelectField = require('./DefaultSelectField/DefaultSelectField.js');
var FieldErrors = require('./FieldErrors/FieldErrors.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const FIELD_DROPDOWN_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldDropdown on Field_Dropdown {
    __typename
    ...fieldBase
    multi
    options {
      ...fieldOption
    }
  }
`);
const Field_Dropdown = createFieldControl.createField(FIELD_DROPDOWN_FRAGMENT, (field, { methods })=>{
    var _options_;
    const { options: _options, defaultValue: maybeDefaultValue, handle, label, placeholder, required, instructions } = field;
    const { defaultValue: defaultValueSingle, defaultValues, options } = useFieldOptions(_options);
    const multi = field.__typename === 'Field_Dropdown' ? field.multi : false;
    const { control } = methods;
    var _ref, _ref1;
    const defaultValue = multi ? defaultValues : (_ref1 = (_ref = maybeDefaultValue != null ? maybeDefaultValue : defaultValueSingle) != null ? _ref : (_options_ = options[0]) == null ? void 0 : _options_.value) != null ? _ref1 : '';
    const _useController = reactHookForm.useController({
        name: handle,
        control,
        defaultValue
    }), { field: { ref }, fieldState: { error } } = _useController, controlledField = _object_without_properties_loose(_useController.field, [
        "ref"
    ]);
    return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(DefaultSelectField.DefaultSelectField, _extends({}, controlledField, {
                SelectProps: {
                    ref,
                    multiple: Boolean(multi)
                },
                error: !!error,
                helperText: instructions,
                label,
                placeholder,
                required,
                options
            })),
            /*#__PURE__*/ jsxRuntime.jsx(FieldErrors, {
                errors: error
            })
        ]
    });
});

exports.FIELD_DROPDOWN_FRAGMENT = FIELD_DROPDOWN_FRAGMENT;
exports.Field_Dropdown = Field_Dropdown;
